import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.correction.audit.modal.title',
    defaultMessage: 'PROBLEM(S) SOLVED',
  },
  message: {
    id: 'simulated.correction.audit.modal.message',
    defaultMessage:
      'Corrections have been successfully saved. Check and correct other errors as well',
  },
  continue: {
    id: 'simulated.correction.audit.modal.continue',
    defaultMessage: 'Continue',
  },
});
